import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import DropList from 'components/atoms/DropList';
import Form from 'components/atoms/Form';
import FormGroup from 'components/atoms/FormGroup';
import Icon from 'components/atoms/Icon';
import Label from 'components/atoms/Label';
import { OUTLINE_INTERVALS } from 'data/static';
import { bindActionCreators, Dispatch } from 'redux';
import { setOutlineIntervalAction } from 'store/actions/mapActions';
import { RootState } from 'types';
import { ActionsType } from 'types/system';
import { renderError, setKey } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface ChangeIntervalModelProps {
    children?: string | JSX.Element | JSX.Element[];
    title?: string;
    language: string;
    id?: string;
    data: any;
    actions: ActionsType | undefined;
    setOutlineIntervalAction: (outlineInterval: number) => void;
}

interface ChangeIntervalModelState {
    language: string;
    errors: object;
    data: any | null;
    times: number[];
    id?: string;
    isLoading: boolean;
}

class ChangeIntervalModel extends Component<ChangeIntervalModelProps, ChangeIntervalModelState> {
    constructor(props: ChangeIntervalModelProps) {
        super(props);
        this.state = {
            data: null,
            isLoading: false,
            times: OUTLINE_INTERVALS,
            errors: {},
            language: 'en',
        };
    }

    componentDidMount(): void {
        this.setState({ data: this.props.data });
    }

    handleChange = (name: string, value: unknown) => {
        const { data, errors } = this.state;
        setKey(data, name, value);
        setKey(errors, name, null);
        this.setState({ data, errors });
    };

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.setOutlineIntervalAction(parseInt(this.state.data.outlineInterval));
        this.props.actions?.onCancel();
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    render() {
        return (
            <Form onSubmit={this.handleFormSubmit} className="bg-white shadow w-mediumModel  rounded ">
                <div className="p-4 no-select">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between">
                        <div className="text-lg leading-6 font-bold">{translate('Change interval')}</div>
                        <div className="cursor-pointer" onClick={this.handleFormCancel}>
                            <Icon className="w-6 h-6">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>
                    <FormGroup comments={renderError(this.state.errors?.['outlineInterval'])} required={false}>
                        <Label>{translate('Time interval : by seconds')}</Label>

                        <DropList
                            capitalize
                            name="outlineInterval"
                            onChange={this.handleChange}
                            options={this.state.times.map((time) => {
                                return { label: String(time), value: time };
                            })}
                            value={this.state?.data?.outlineInterval}
                        ></DropList>
                    </FormGroup>
                    <div className="flex justify-end pt-4 ">
                        <div className="flex gap-2 items-center">
                            <Button
                                className="px-4 py-2 font-bold border border-gray-200"
                                onClick={this.handleFormCancel}
                            >
                                {translate('No , Cancel')}
                            </Button>
                            <Button type="submit" className="px-4 py-2 bg-primary-submit rounded-md text-white">
                                {translate('Yes , Save')}
                            </Button>
                        </div>
                    </div>
                </div>
            </Form>
        );
    }
}

const changeIntervalModelStateToProps = (state: RootState) => ({
    language: state.user.user.language,
});

const changeIntervalModelDispatchToProps = (dispatch: Dispatch) => ({
    setOutlineIntervalAction: bindActionCreators(setOutlineIntervalAction, dispatch),
});

export default connect(changeIntervalModelStateToProps, changeIntervalModelDispatchToProps)(ChangeIntervalModel);
